/**
 * Created by Languagenut on 17/09/2019.
 */


import React  from 'react';
import Translation from '../../store/internationalization-store.js';
import {Card , Row , Col , Media} from 'react-bootstrap';

export default class TotalsBlock extends React.Component {


    constructor(props) {
        super();
        this.props = props;
        this.state = {
            
        };
    }

    componentWillReceiveProps(props){
        this.props  = props;
        this.setState({update:true});
    }

    MedalCard(title , img, data){
        if (data == undefined || data == null) {
            return "";
        }
        return <Col md={3}><Media>
            <img

                height={50}
                className="mr-3"
                src={img || "https://via.placeholder.com/64"}
                alt="Generic placeholder"
                />
            <Media.Body>
                <b>{title}</b>
                <h4>{data}</h4>
            </Media.Body>
        </Media></Col>
    }

    render(){
        if (this.props.statistics == undefined) {
            return "";
        }
        var rankStuff = this.MedalCard(Translation.get(12606 , 'School World Ranking') , './img/icons/languageSelect.png',this.props.statistics.rank);
        if (this.props.isStudent == true) {
            rankStuff = this.MedalCard(Translation.get(2413 , 'Student World Ranking') , './img/icons/languageSelect.png',this.props.statistics.rank);
        }
        var dataStuff = "";
        if (this.props.statistics.examsCompleted == null) {
                dataStuff = [this.MedalCard(Translation.get(12602, 'Grammar Units Learnt') , './img/icons/grammar.png',this.props.statistics.grammarLearnt),
            this.MedalCard(Translation.get(12193 , 'Verbs Learnt') , './img/icons/languageCourse.png',this.props.statistics.verbLearnt)]
        } else {
            dataStuff = [this.MedalCard(Translation.get(12603, 'Grammar & Verbs Learnt') , './img/icons/grammar.png',parseInt(this.props.statistics.grammarLearnt || 0) + parseInt(this.props.statistics.verbLearnt || 0)),
            this.MedalCard(Translation.get(12604 , 'Exam Skills Learnt') , './img/icons/languageCourse.png',this.props.statistics.examsCompleted)]
        }
        return <Card body>
            <Row>
                {this.MedalCard(Translation.get(12605 , 'Vocabulary Learnt') , './img/icons/languageCourse.png',this.props.statistics.vocabLearnt)}
                {this.MedalCard(Translation.get(12194 , 'Sentences Learnt') , './img/icons/sentenceBuilding.png',this.props.statistics.sentenceLearnt)}
                {dataStuff}
            </Row>
            <br/>
            <Row>
                {this.MedalCard(Translation.get(12189 , 'Total Gold') , './img/icons/Medals-03.png',this.props.statistics.goldMedals)}
                {this.MedalCard(Translation.get(12190 , 'Total Silver')  , './img/icons/Medals-02.png',this.props.statistics.silverMedals)}
                {this.MedalCard(Translation.get(12191 , 'Total Bronze') , './img/icons/Medals-01.png',this.props.statistics.bronzeMedals)}
                {rankStuff}
            </Row>
        </Card>
    }
}